import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import axios from 'axios';
const apiUrl = process.env.REACT_APP_API_URL;
const API_BASE = `${apiUrl}/api/v1/users`;

export const fetchUserProfile = createAsyncThunk(
  'user/fetchUserProfile',
  async (_, { rejectWithValue, getState }) => {
    try {
      const { access_token } = getState().auth;
      const response = await axios.get(`${API_BASE}/profile`, {
        headers: { Authorization: `Bearer ${access_token}` },
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const updateUserProfile = createAsyncThunk(
  'user/updateUserProfile',
  async (profileData, { rejectWithValue, getState }) => {
    try {
      const { access_token } = getState().auth;
      const response = await axios.patch(
        `${API_BASE}/profile`,
        profileData,
        { headers: { Authorization: `Bearer ${access_token}` } }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const changePassword = createAsyncThunk(
  'user/changePassword',
  async (passwordData, { rejectWithValue, getState }) => {
    try {
      const { access_token } = getState().auth;
      const response = await axios.patch(
        `${API_BASE}/change-password`,
        passwordData,
        { headers: { Authorization: `Bearer ${access_token}` } }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const userSlice = createSlice({
  name: 'user',
  initialState: {
    profile: null,
    profileStatus: null,
    profileError: null,
    updateStatus: null,
    updateError: null,
    passwordStatus: null,
    passwordError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateUserProfile.fulfilled, (state, action) => {
        state.profile = action.payload;
        state.updateStatus = 'success';
        state.updateError = null;
      })
      .addCase(fetchUserProfile.pending, (state) => {
        state.profileStatus = 'loading';
        state.profileError = null;
      })
      .addCase(fetchUserProfile.fulfilled, (state, action) => {
        state.profile = action.payload;
        state.profileStatus = 'success';
        state.profileError = null;
      })
      .addCase(fetchUserProfile.rejected, (state, action) => {
        state.profileStatus = 'failed';
        state.profileError = action.payload || action.error.message;
      })
      .addCase(updateUserProfile.rejected, (state, action) => {
        state.updateStatus = 'failed';
        state.updateError = action.payload;
      })
      .addCase(updateUserProfile.pending, (state) => {
        state.updateStatus = 'loading';
        state.updateError = null;
      })
      .addCase(changePassword.fulfilled, (state) => {
        state.passwordStatus = 'success';
        state.passwordError = null;
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.passwordStatus = 'failed';
        state.passwordError = action.payload;
      })
      .addCase(changePassword.pending, (state) => {
        state.passwordStatus = 'loading';
        state.passwordError = null;
      });
  },
});

export default userSlice.reducer;
